import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { show } from 'redux-modal';
import { isNgWordLoading } from 'selectors/loading';
import { listRequest, createRequest, batchDeleteRequest } from 'actions/ngwords';
import { getNgWords, getNgWordCurrentPage, getNgWordPageSize } from 'selectors/lists';
import { getNGWordLanguageOptions } from 'selectors/options';
import { NG_WORD_ADD_MODAL, NG_WORD_ADD_FORM } from 'misc/constants';
import PureRenderComponent from 'components/core/PureRenderComponent';
import NGWord from './presenter';

class NGWordContainer extends PureRenderComponent {

  constructor(props) {
    super(props);
    this.state = {
      client: '',
      language: '',
      keyword: '',
      selected: [],
    }
  }

  componentDidMount() {
    const params = { page: this.props.currentPage };
    this.props.listRequest(params);
  }

  handlePageSelect = (page) => {
    const { client, keyword, language } = this.state;
    this.props.listRequest({ client, keyword, language, page });
  }

  handleClientChange = (client) => {
    this.setState({ client })
    this.props.listRequest({
      client,
      page: 1,
      keyword: this.state.keyword,
      language: this.state.language,
    });
    this.setState({ selected: [] })
  }

  handleLanguageChange = (language) => {
    this.setState({ language })
    this.props.listRequest({
      language,
      page: 1,
      keyword: this.state.keyword,
      client: this.state.client,
    });
    this.setState({ selected: [] })
  }

  handleKeywordChange = (keyword) => {
    this.setState({ keyword })
  }

  handleSubmit = () => {
    const { client, keyword, language } = this.state;
    this.props.listRequest({
      keyword,
      client,
      language,
      page: this.props.currentPage
    });
  }

  handleAdd = (values) => {
    this.props.createRequest(NG_WORD_ADD_FORM, values);
  }

  showAddModal = () => {
    this.props.show(NG_WORD_ADD_MODAL, {
      handleAddNGWord: this.handleAdd,
      languageOptions: this.props.languageOptions,
    })
  }

  handleSelect = (e) => {
    const { checked, value } = e.target;
    const newValue = [...this.state.selected];
    checked
      ? newValue.push(value)
      : newValue.splice(newValue.indexOf(value), 1)
    this.setState({ selected: newValue });
  }

  handleDelete = () => {
    this.props.batchDeleteRequest({ items: this.state.selected });
    this.setState({ selected: [] });
  }

  render() {
    return (
      <NGWord
        {...this.props}
        selected={this.state.selected}
        client={this.state.client}
        keyword={this.state.keyword}
        language={this.state.language}
        handleSubmit={this.handleSubmit}
        handleClientChange={this.handleClientChange}
        handleKeywordChange={this.handleKeywordChange}
        handleLanguageChange={this.handleLanguageChange}
        handlePageSelect={this.handlePageSelect}
        handleSelect={this.handleSelect}
        handleDelete={this.handleDelete}
        showAddModal={this.showAddModal}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    ngWords: getNgWords(state),
    isLoading: isNgWordLoading(state),
    languageOptions: getNGWordLanguageOptions(state),
    pageSize: getNgWordPageSize(state),
    currentPage: getNgWordCurrentPage(state),
  }
}

const mapDispatchToProps = (disptach) => {
  return bindActionCreators({
    show,
    listRequest,
    createRequest,
    batchDeleteRequest,
  }, disptach)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NGWordContainer);
